import { css } from "../../../../../styled-system/css";

export const styles = {
  socialMediaWrapper: () =>
    css({
      display: "flex",
      marginTop: "baseUnit.mobile2",
      desktop: {
        marginTop: 0,
      },
      "& a": {
        marginRight: "baseUnit.mobile3",
        _lastOfType: {
          marginRight: 0,
        },
      },
    }),
};
